
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'プロジェクト実績' },
    { number: '15年', label: '平均経験年数' },
    { number: '98%', label: '顧客満足度' },
    { number: '24h', label: '平均回答時間' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              信頼と実績で選ばれる<br />
              コンサルティングパートナー
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              私たちは15年以上にわたり、様々な業界の企業様の成長を支援してまいりました。
              豊富な経験と専門知識、そして何より「お客様の成功」を第一に考える姿勢で、
              多くの企業様から信頼をいただいております。
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <i className="ri-shield-check-line text-blue-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">確かな実績と信頼</h4>
                  <p className="text-gray-600">500社以上の企業様との取引実績</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-user-star-line text-blue-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">経験豊富な専門家</h4>
                  <p className="text-gray-600">各分野のエキスパートが在籍</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-customer-service-2-line text-blue-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">手厚いサポート</h4>
                  <p className="text-gray-600">プロジェクト完了後も継続的にサポート</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-blue-600 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/91058f0e880faec44d9af48b4c7bf5f8.jpg"
              alt="About Us"
              className="rounded-xl shadow-lg object-cover w-full h-96 lg:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
